import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sideBarTikets"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("h4", null, "Билеты", -1)
const _hoisted_3 = { class: "sideBarTikets__wrap" }
const _hoisted_4 = { class: "offer__title" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "planeSq" }, null, -1)
const _hoisted_6 = { class: "offer__list" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "pdf" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_ctx.convertOffert && _ctx.convertOffert.length > 0)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.convertOffert, (item) => {
            return (_openBlock(), _createBlock("div", {
              class: "offer",
              key: item.offer.orderId
            }, [
              _createVNode("div", _hoisted_4, [
                _hoisted_5,
                _createTextVNode(" Заказ №" + _toDisplayString(item.offer.orderId), 1 /* TEXT */)
              ]),
              _createVNode("ul", _hoisted_6, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.offerTicket, (ticket) => {
                  return (_openBlock(), _createBlock("li", {
                    key: ticket.offerTicketId,
                    onClick: $event => (_ctx.loadDoc(ticket.offerTicketId, ticket.fileName))
                  }, [
                    _createVNode("span", {
                      title: ticket.fileName
                    }, _toDisplayString(ticket.fileName), 9, ["title"]),
                    _hoisted_7
                  ], 8, ["onClick"]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]))
    : _createCommentVNode("", true)
}